import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";
import CreateRights from "./rights/CreateRights";
import CreateGallery from "./gallery/CreateGallery";
import CreateDegree from "./degree/CreateDegree";
import CreateCountry from "./country/CreateCountry";
import CreateCity from "./city/CreateCity";
import CreateState from "./state/CreateState";
import CreateService from "./service/CreateService";
import CreateSpecialty from "./specialties/CreateSpecialty";
import CreateFacility from "./facility/CreateFacility";
import CreateHospitalType from "./hospitaltype/CreateHospitalType";
import CreateShiftSettings from "./shiftsettings/CreateShiftSettings";
import CreateBranch from "./branch/CreateBranch";
import CreateAppointment from "./Appointment/CreateAppointment";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    menuForm: <CreateMenu />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
    rightsForm: <CreateRights />,
    galleryForm: <CreateGallery />,
    degreeForm: <CreateDegree />,
    countryForm: <CreateCountry />,
    stateForm: <CreateState />,
    cityForm: <CreateCity />,
    serviceForm: <CreateService />,
    specialityForm: <CreateSpecialty />,
    facilityForm: <CreateFacility />,
    hospitalTypeForm: <CreateHospitalType />,
    shiftSettingsForm: <CreateShiftSettings />,
    branchForm: <CreateBranch />,
    appointmentForm: <CreateAppointment />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
